import { FC, memo } from 'react';

import Grid2 from '../../../../../src/components/grid/Grid2';
import { H2, H3 } from '../../../../../src/components/heading/Hx';
import List from '../../../../../src/components/list/List';
import ListItem from '../../../../../src/components/list/ListItem';
import Route from '../../../../../src/components/route/Route';
import { RoutePath } from '../../../../../src/components/route/type';
import Section from '../../../../../src/components/section/Section';
import { Strong } from './styled';

const Results: FC = () => (
  <Section>
    <H2>Was wirst Du erreichen?</H2>
    <Grid2 spacing='2rem'>
      <Grid2.Item>
        <H3>Deine Ergebnisse</H3>
        <List bullets>
          <ListItem>
            Durch gezielte Atemtechniken und Grundübungen formst Du Deinen Körper zu einer
            harmonischen Einheit. Diese Übungen stärken Deine Muskulatur und unterstützen Deine
            Regeneration. In einer entspannten Atmosphäre wirst Du Ängste und Blockaden abbauen und
            ein Gefühl von Entspannung und Selbstsicherheit erreichen.
          </ListItem>
          <ListItem>
            Das Training fördert Deine Beweglichkeit, Körperhaltung und Dein Körpergefühl.
            Fehlhaltungen werden korrigiert, alte Verletzungen heilen, und Du wirst Dich jünger und
            vitaler fühlen. Du entwickelst eine tiefere geistige Flexibilität und lernst, Dich
            konzentriert und präzise zu bewegen.
          </ListItem>
          <ListItem>
            Durch ein neues Körperbewusstsein lernst Du, mit weniger Aufwand mehr zu erreichen. Du
            findest kreative Lösungen für komplexe Herausforderungen und entwickelst ein neues
            Lebensgefühl. Dein Verständnis von Realität und Zeit verändert sich, was zu einem neuen
            Lebensgefühl und mehr Lebenskompetenz führt.
          </ListItem>
          <ListItem>
            Unser auf <Route href={RoutePath.AlexanderSolovev}>militärischem Nahkampf</Route>{' '}
            basierendes System programmiert Dein Muskelgedächtnis und automatisiert wichtige
            Techniken für den Notfall. Dadurch wirst Du bestens vorbereitet, um Dich in
            verschiedenen Situationen zu verteidigen.
          </ListItem>
        </List>
      </Grid2.Item>
      <Grid2.Item>
        <H3>Deine Vorteile</H3>
        <List bullets>
          <ListItem>
            <Strong>Wachstum und innere Stärke</Strong>
            Von den Grundlagen bis zur Meisterschaft – Du wirst Deine Grenzen testen und über Dich
            hinauswachsen. Das Training hilft Dir, Deine Ängste zu überwinden und Deine innere
            Stärke zu entfalten.
          </ListItem>
          <ListItem>
            <Strong>Selbsterkenntnis & Selbstbewusstsein</Strong>
            Durch das Arbeiten mit natürlichen Bewegungen und Reflexen entwickelst Du ein tiefes
            Verständnis von Dir selbst, das Dein Selbstbewusstsein stärkt.
          </ListItem>
          <ListItem>
            <Strong>Erhöhte Alltagskompetenz</Strong>
            Die Prinzipien von Systema sind auf den Alltag übertragbar. Du wirst leistungsfähiger,
            konzentrierter und erfolgreicher in Beruf und Freizeit.
          </ListItem>
          <ListItem>
            <Strong>Verbesserte Intuition</Strong>
            Du entwickelst ein feines Gespür für effektive Lösungen und lernst, Herausforderungen
            mit Ausdauer und Kreativität zu begegnen.
          </ListItem>
        </List>
      </Grid2.Item>
    </Grid2>
  </Section>
);

export default memo(Results);
